import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromOrders from '@features/orders/reducers/orders.reducer';
import { applyOrderItemAudit } from '@features/orders/actions/apply-order-item-audit.actions';
import { loadOrderItemAudit } from '@features/orders/actions/load-order-item-audit.actions';
import { cancelOrderItem } from '@features/orders/actions/cancel-order-item.actions';
import { OrderItem } from '@shared/models/order-item';
import { EsetSubscriptionsService } from './eset-subscriptions.service';
import { EsetSubscription } from '@shared/models/eset-subscription';
import { LoadingState } from '@shared/types/loading-state';

@Injectable({
  providedIn: 'root',
})
export class OrderItemsService {
  constructor(
    private store: Store,
    private esetSubscriptionsService: EsetSubscriptionsService,
  ) {}

  loadOrderItemAudit(orderId: number, orderItemId: number) {
    this.store.dispatch(loadOrderItemAudit({ orderId, orderItemId }));
  }

  applyOrderItemAudit(orderId: number, orderItemId: number) {
    this.store.dispatch(applyOrderItemAudit({ orderId, orderItemId }));
  }

  cancelOrderItem(orderId: number, orderItemId: number, reason: string) {
    this.store.dispatch(cancelOrderItem({ orderId, orderItemId, reason }));
  }

  getOrderItemLoadingState(): Observable<LoadingState> {
    return this.store.select(fromOrders.selectOrderItemLoadingState);
  }

  getOrderItemLoadingText(): Observable<string | undefined> {
    return this.store.select(fromOrders.selectOrderItemLoadingText);
  }

  getOrderItemAuditPreview(): Observable<OrderItem | undefined> {
    return this.store.select(fromOrders.selectOrderItemAuditPreview);
  }

  isExpired(orderItem: OrderItem): boolean {
    if (orderItem.attributes.itemable?.type == 'eset_subscription') {
      return this.esetSubscriptionsService.isExpired(orderItem.attributes.itemable as EsetSubscription);
    }
    return false;
  }

  isExpiring(orderItem: OrderItem): boolean {
    if (orderItem.attributes.itemable?.type == 'eset_subscription') {
      return this.esetSubscriptionsService.isExpiring(orderItem.attributes.itemable as EsetSubscription);
    }
    return false;
  }

  isRenewable(orderItem: OrderItem): boolean {
    if (orderItem.attributes.itemable?.type == 'eset_subscription') {
      return this.esetSubscriptionsService.isRenewable(orderItem.attributes.itemable as EsetSubscription);
    }
    return false;
  }

  canBeExtended(orderItem: OrderItem): boolean {
    if (orderItem.attributes.itemable?.type == 'eset_subscription') {
      return this.esetSubscriptionsService.canBeExtended(orderItem.attributes.itemable as EsetSubscription);
    }
    return false;
  }

  canBeConverted(orderItem: OrderItem): boolean {
    if (orderItem.attributes.itemable?.type == 'eset_subscription') {
      return this.esetSubscriptionsService.canBeConverted(orderItem.attributes.itemable as EsetSubscription);
    }
    return false;
  }
}
